import { Typography } from "@mui/material";


interface BracketRoundHeaderProps {
    index: number;
    bracketRegions: number;
    factor: number;
}


export const BracketRoundHeader = ({index, bracketRegions, factor}: BracketRoundHeaderProps) => {

    const players = Math.pow(2,index+1)*bracketRegions;

    return (
        <Typography sx={{fontSize: 14*factor, fontWeight: '500', width: '100%', textAlign: 'center'}}>
            {
                players === 8 ?
                'Quarterfinals' :
                players === 4 ?
                'Semifinals' :
                players === 2 ?
                'Finals' :
                players === 1 ?
                `   ` :
                `Round of ${players}`
            }
        </Typography>
    )
}
